import { action, observable } from "mobx";
import EshopError from "../models/eshopError";
import ChargeTypesService from "./chargeTypesService";
import EventBus, { vehicleChargeOrderInstructions, vehicleChargeValidityInstructions } from "./eventBus";
import type { IVehicle } from "../models/types";
import VehicleRepository from "../repositories/vehicleRepository";
import ChargeRegistrationsResponse from "entities/chargeRegistrationsResponse";
import ChargeOrderInstructionRequest from "entities/chargeOrderInstructionRequest";
import ChargeOrderItem from "models/chargeOrderItem";
import ChargesRequest from "entities/chargesRequest";
import TimeService from "./timeService";
import { dateToIsoDate } from "../utils/dateUtils";

export default class VehicleService {
  @observable chargeRegistrationsResponse: ChargeRegistrationsResponse;
  @observable vehicle?: IVehicle;

  constructor(
    private vehicleRepository: VehicleRepository,
    private timeService: TimeService,
    private eventBus: EventBus,
    private chargeTypesService: ChargeTypesService
  ) {}

  @action.bound
  getChargeOrderInstructions(items: ChargeOrderItem[]) {
    const charges = items.map(charge => {
      return {
        licensePlates: [...charge.licensePlates],
        countryId: charge.countryId,
        fuelTypeId: charge.fuelTypeId,
      };
    }) as unknown as ChargeOrderInstructionRequest[];
    return this.vehicleRepository
      .getChargeOrderInstructions(charges)
      .then(response => {
        this.eventBus.publish(
          vehicleChargeOrderInstructions({ chargeOrderInstructionGroups: response instanceof EshopError ? undefined : response })
        );
      })
      .catch(() => this.eventBus.publish(vehicleChargeOrderInstructions({ chargeOrderInstructionGroups: undefined })));
  }
  @action.bound
  getChargeValidityInstructions(items: ChargeOrderItem[]) {
    const charges = items.map(charge => {
      return {
        licensePlates: [...charge.licensePlates],
        countryId: charge.countryId,
        priceListItemId: charge.priceListItemId,
        validity: {
          validSinceDate: charge._hasImmediateValidity
            ? undefined
            : charge.validSince
            ? dateToIsoDate(charge.validSince)
            : charge.validSince,
          hasImmediateValidity: charge._hasImmediateValidity,
        },
      };
    }) as unknown as ChargesRequest[];
    return this.vehicleRepository
      .getChargeValidityInstructions(charges)
      .then(response => {
        this.eventBus.publish(
          vehicleChargeValidityInstructions({
            chargeValidityInstructionGroups: response instanceof EshopError ? undefined : response,
            charges: charges,
          })
        );
      })
      .catch(() => this.eventBus.publish(vehicleChargeValidityInstructions({ chargeValidityInstructionGroups: undefined })));
  }
}
